import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import PlatformStrip from "./components/PlatformStrip";
import HotList from "./components/HotList";
import TopicSection from "./components/TopicSection";
import DiscussionSection from "./components/DiscussionSection";
import CategoryBrowser from "./components/CategoryBrowser";
import About from "./components/About";
import Faq from "./components/Faq";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <PlatformStrip />
        <HotList />
        <TopicSection />
        <DiscussionSection />
        <CategoryBrowser />
        <About />
        <Faq />
        <ContactForm />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "娜娜51贴吧热议圈 - 首页",
            description:
              "聚合贴吧、知乎、论坛、热搜上的娜娜51相关热帖与讨论精华，围观网友热评与话题风向。",
            url: "https://archivex.cn/",
            isPartOf: { "@type": "WebSite", name: "娜娜51贴吧热议圈", url: "https://archivex.cn/" },
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "首页", item: "https://archivex.cn/" },
              ],
            },
          }),
        }}
      />
    </div>
  );
}